import React from "react";
import { KanbanSpacesPage } from "./KanbanSpacesPage";
import { useKanbanSpaces } from "./useKanbanSpaces";

function KanbanSpaces() {
  return <KanbanSpacesPage {...useKanbanSpaces()} />;
}

export default KanbanSpaces;
